import { composeFieldPath } from '@northfork/basics'
import { BulkExternalData } from '../bulk-misc-model'
import { TransactionTypeLabel } from '../bulk-transaction'
export const tradeField = composeFieldPath([] as BulkTradeEntryRow[])

export interface BulkTradeEntryRow extends BulkExternalData {
  rowId: string
  rowNumber?: string
  accountId: string
  tranType: string
  entryDate: string
  settleDate: string
  postDate: string
  assetId: string
  price?: string
  units?: string
  factor?: string
  inventoryType?: string
  commission: string
  originationFee?: string
  exitFee?: string
  exitFeeReceivable?: string
  drawFee?: string
  prepaymentPenaltyFee?: string
  prepaidInterest?: string
  interestDue?: string
  interestBearingInterestReserve?: string
  interestBearingPrincipalReserve?: string
  nonInterestBearingInterestReserve?: string
  nonInterestBearingPrincipalReserve?: string
  dollarAccrued: string
  proceeds: string
  counterParty: string
  validityStatus: 'valid' | 'invalid' | 'warning' | 'inactive' | 'intermediate'
  errorMessageMap: Map<string, string[]>
  legacyOrigTranId?: number
  sleeveAccountId?: number
  buyType?: string
  cleared: boolean
  collateralBroker?: string
  isHplAccount?: boolean
  orderId?: string
  transactionTypeLabel?: TransactionTypeLabel
}

export interface ErrorMessageRow {
  field: string
  errorMessages: string[]
}

export interface SecurityInputInfoTradeKey {
  cusip: string
  settleDate: string
}
